import React from 'react';
import { useNavigate } from 'react-router-dom';
import { markNotificationAsRead } from '../../services/notificationService';
import Button from '../common/Button';
import { Caption, Typography } from '../common/Typography';
import CollapsibleNotificationItem from '../notifications/CollapsibleNotificationItem';

const ClubReactivationNotificationItem = ({
  notification,
  onUpdate,
  onClose,
}) => {
  const navigate = useNavigate();
  const data = notification.data || {};
  const clubId = data.club_id;
  const clubName = data.club_name || 'the club';
  const playerName = data.player_name || 'A player';
  const type = notification.type;

  const isAdminRequest = type === 'club_reactivation_requested';
  const isApproved = type === 'club_reactivation_approved';

  const handleOpen = async () => {
    if (notification.id && !notification.is_read) {
      try {
        await markNotificationAsRead(notification.id);
      } catch (err) {
        console.error('Error marking notification as read:', err);
      }
    }
    onClose?.();
    if (!clubId) {
      onUpdate?.();
      return;
    }
    if (isAdminRequest) {
      navigate(`/club/${clubId}/settings`, {
        state: { activeTab: 'player-management', selectedClub: { id: clubId } },
      });
    } else {
      navigate(`/clubs/${clubId}`);
    }
    onUpdate?.();
  };

  return (
    <CollapsibleNotificationItem
      notification={notification}
      borderColor={isApproved ? 'green' : 'blue'}
      badgeVariant={isApproved ? 'success' : 'info'}
      detailsContent={
        isAdminRequest ? (
          <div className="text-sm">
            <span className="text-text-muted">Player: </span>
            <Typography variant="strong" as="span">{playerName}</Typography>
          </div>
        ) : null
      }
      metadata={clubName ? <Caption>Club: {clubName}</Caption> : null}
    >
      <Button variant="primary" size="small" onClick={handleOpen}>
        {isAdminRequest ? 'Review request' : 'View club'}
      </Button>
    </CollapsibleNotificationItem>
  );
};

export default ClubReactivationNotificationItem;
